$(document).ready(function () {
	var inNav = false;
	var inMenu = false;

	$('[navdrop]').mouseenter(function () {
		inMenu = true;
		$('.navDrop').slideDown();
		var navDropCheck = setInterval(checkMouse, 100);

		function checkMouse() {
			if (inMenu == false && inNav == false) {
				$('.navDrop').slideUp();
				clearInterval(navDropCheck);
			}
		}
	});

	$('[subdrop]').mouseenter(function () {
		$(this).find('.sub-menu').slideDown();
	});

	$('[subdrop]').mouseleave(function () {
		$(this).find('.sub-menu').slideUp();
	});

	$('.navDrop').mouseenter(function () {
		inNav = true;
	});

	$('[navdrop]').mouseleave(function () {
		inMenu = false;
	});

	$('.navDrop').mouseleave(function () {
		inNav = false;
	});

	$('[mobile-nav-open]').on('click', function () {
		$('.navMob').fadeIn();
	});

	$('.navMob__close').on('click', function () {
		$('.navMob').fadeOut();
	});

	$('[subnavopen]').on('click', function () {
		var target = $(this).attr('subnavopen');
		$('[subnav="' + target + '"]').fadeIn();
	});

	$('[closesub]').on('click', function () {
		$(this).parent().parent().parent().fadeOut();
	});

	function pageLoadFunctions() {
		//accordion code -----------------------------------------------------------------

		$('.homeProcess__accTitle').on('click', function () {
			if (
				$(this).parent().find('.homeProcess__accDrawer').is(':visible')
			) {
			} else {
				$('.homeProcess__accDrawer').slideUp();
				$(this).parent().find('.homeProcess__accDrawer').slideDown();
				var thisThing = $(this);
				$('.homeProcess__img').attr(
					'src',
					thisThing.attr('data-image')
				);
			}
		});

		$('.homeFAQ__accTitle').on('click', function () {
			if ($(this).parent().find('.homeFAQ__accDrop').is(':visible')) {
				$(this).parent().find('.homeFAQ__accDrop').slideUp();
			} else {
				$('.homeFAQ__accDrop').slideUp();
				$(this).parent().find('.homeFAQ__accDrop').slideDown();
			}
		});

		$('.prodMain__accordionTitle').on('click', function () {
			if (
				$(this)
					.parent()
					.find('.prodMain__accordionTextWrapper')
					.is(':visible')
			) {
				$(this)
					.parent()
					.find('.prodMain__accordionTextWrapper')
					.slideUp();
			} else {
				$('.prodMain__accordionTextWrapper').slideUp();
				$(this)
					.parent()
					.find('.prodMain__accordionTextWrapper')
					.slideDown();
			}
		});

		// Legacy Charm Code
		$('.legacyCharmProcess__accTitle').on('click', function () {
			if (
				$(this)
					.parent()
					.find('.legacyCharmProcess__accDrawer')
					.is(':visible')
			) {
			} else {
				$('.legacyCharmProcess__accDrawer').slideUp();
				$(this)
					.parent()
					.find('.legacyCharmProcess__accDrawer')
					.slideDown();
				var thisThing = $(this);
				$('.legacyCharmProcess__img').attr(
					'src',
					thisThing.attr('data-image')
				);
			}
		});

		$('.legacyCharmFAQ__accTitle').on('click', function () {
			if (
				$(this).parent().find('.legacyCharmFAQ__accDrop').is(':visible')
			) {
				$(this).parent().find('.legacyCharmFAQ__accDrop').slideUp();
			} else {
				$('.legacyCharmFAQ__accDrop').slideUp();
				$(this).parent().find('.legacyCharmFAQ__accDrop').slideDown();
			}
		});

		//product page code -------------------------------------------------------------

		function selectVariant() {
			console.log('🔍 selectVariant() called');
			
			var optionValues = [];
			
			$('.prodMain__optionWrapper').each(function () {
				var contribution = $(this)
					.find('.prodMain__option--selected')
					.attr('data-value');
				if (contribution) {
					optionValues.push(contribution);
				}
			});
			
			console.log('📊 Selected option values:', optionValues);
			
			if (optionValues.length > 0) {
				var foundOption = null;
				
				// Handle single option products differently (match by value)
				if (optionValues.length === 1) {
					var targetValue = optionValues[0];
					console.log('🎯 Single option product. Looking for value:', targetValue);
					
					foundOption = $('.prodMain__hiddenSelector option').filter(function() {
						return $(this).val() === targetValue;
					});
					
				} else {
					// ✅ FLEXIBLE: Handle ANY multi-option product (2, 3, 4, 5+ options)
					console.log('🎯 Multi-option product (' + optionValues.length + ' options). Looking for:', optionValues.join(' / '));
					
					// Find option where ALL selected values appear in the option text
					$('.prodMain__hiddenSelector option').each(function() {
						var optionText = $(this).text().trim();
						var allValuesMatch = true;
						
						// Check if EVERY selected value appears in this option text
						for (var i = 0; i < optionValues.length; i++) {
							if (!optionText.includes(optionValues[i])) {
								allValuesMatch = false;
								break; // Stop checking this option
							}
						}
						
						// If all values matched, we found our variant!
						if (allValuesMatch) {
							foundOption = $(this);
							console.log('   ✅ MATCH FOUND:', optionText);
							return false; // Break out of the .each() loop
						}
					});
				}
				
				if (foundOption && foundOption.length > 0) {
					var variantPrice = foundOption.attr('variant-price');
					var variantId = foundOption.attr('variant-id');
					
					console.log('✅ Found matching variant:');
					console.log('   - Option text:', foundOption.text().trim());
					console.log('   - Option value:', foundOption.val());
					console.log('   - Variant ID:', variantId);
					console.log('   - Price:', variantPrice);
					
					// CRITICAL: Set by exact index position, not value
					var selector = $('.prodMain__hiddenSelector')[0];
					var targetIndex = foundOption.index();
					selector.selectedIndex = targetIndex;
					console.log('✅ Set dropdown to index:', targetIndex);
					
					// ENHANCED: Try multiple methods to update Bold forms
					updateBoldForms(variantId);
					
					// Update price displays
					$('.prodMain__price').text(variantPrice);
					$('[data-bsub-per-delivery-price]').text(variantPrice);
					console.log('✅ Updated prices to:', variantPrice);
					
					// CRITICAL: Trigger change event for Bold widget
					$(selector).trigger('change');
					console.log('✅ Triggered change event for Bold widget');
					
				} else {
					console.log('❌ No matching variant found for options:', optionValues);
					
					// Debug: show all available options
					console.log('📋 Available options:');
					$('.prodMain__hiddenSelector option').each(function(index) {
						console.log('   ' + index + ':', $(this).text().trim(), '(value: ' + $(this).val() + ')');
					});
				}
				
			} else {
				console.log('⚠️ No options selected yet');
			}
		}

		// NEW: Enhanced Bold form update function
		function updateBoldForms(variantId) {
			console.log('� Updating Bold forms with variant ID:', variantId);
			
			// Method 1: Standard cart form
			var standardForm = $('form[action="/cart/add"]');
			if (standardForm.length > 0) {
				var hiddenInput = standardForm.find('input[name="id"]');
				if (hiddenInput.length > 0) {
					hiddenInput.val(variantId);
					console.log('✅ Updated standard form input[name="id"]');
				} else {
					// Create the input if it doesn't exist
					standardForm.append('<input type="hidden" name="id" value="' + variantId + '">');
					console.log('✅ Created new input[name="id"] in standard form');
				}
			}
			
			// Method 2: Bold specific forms
			var boldForms = $('form[data-bsub], form[class*="bsub"], form[id*="bsub"]');
			boldForms.each(function() {
				var hiddenInput = $(this).find('input[name="id"]');
				if (hiddenInput.length > 0) {
					hiddenInput.val(variantId);
					console.log('✅ Updated Bold form input[name="id"]');
				} else {
					$(this).append('<input type="hidden" name="id" value="' + variantId + '">');
					console.log('✅ Created new input[name="id"] in Bold form');
				}
			});
			
			// Method 3: Any form with Bold classes/attributes
			$('[data-bsub-variant-id]').attr('data-bsub-variant-id', variantId);
			$('[data-variant-id]').attr('data-variant-id', variantId);
			
			// Method 4: Update any Bold widget data
			if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter) {
				window.BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', {
					variant_id: variantId
				});
				console.log('✅ Triggered Bold variant change event');
			}
			
			console.log('� Bold form update complete');
		}

		// NEW: Get selling plan dynamically from URL
		function getSellingPlanFromURL() {
			var urlParams = new URLSearchParams(window.location.search);
			var sellingPlan = urlParams.get('selling_plan');
			if (sellingPlan) {
				console.log('� Selling plan from URL:', sellingPlan);
				return parseInt(sellingPlan);
			}
			
			// Check hash as well
			if (window.location.hash.includes('selling_plan=')) {
				var hashMatch = window.location.hash.match(/selling_plan=(\d+)/);
				if (hashMatch) {
					console.log('� Selling plan from hash:', hashMatch[1]);
					return parseInt(hashMatch[1]);
				}
			}
			
			return null;
		}

		$('.prodMain__hiddenSelector').on('change', function () {
			var price = $('.prodMain__hiddenSelector')
				.children(':selected')
				.attr('variant-price');
			$('.prodMain__price').text(price);
		});

		$('.prodMain__option').on('click', function () {
			$(this)
				.parent()
				.find('.prodMain__option')
				.removeClass('prodMain__option--selected');
			$(this).addClass('prodMain__option--selected');
			selectVariant();
		});

		$('.prodMain__qtyMinus').on('click', function () {
			var currentQty = $('.prodMain__qty').text().trim() * 1;
			if (currentQty > 1) {
				$('.prodMain__qty').text(currentQty - 1);
			}
		});

		$('.prodMain__qtyPlus').on('click', function () {
			var currentQty = $('.prodMain__qty').text().trim() * 1;
			$('.prodMain__qty').text(currentQty + 1);
		});

		function prodAddToCart() {
			console.log('� prodAddToCart() function called!');
			
			var selected = $('.prodMain__hiddenSelector').children(':selected');
			var variantId = selected.attr('variant-id') * 1;
			var qty = $('.prodMain__qty').text() * 1;
			
			console.log('Adding to cart:');
			console.log('  - Variant ID:', variantId);
			console.log('  - Quantity:', qty);
			
			// Get selling plan dynamically from URL
			var sellingPlan = getSellingPlanFromURL();
			var cartProperties = {};
			
			if (sellingPlan) {
				cartProperties.selling_plan = sellingPlan;
				console.log('  - Selling Plan:', sellingPlan);
			} else {
				console.log('  - No selling plan (regular purchase)');
			}
			
			console.log('  - Properties:', cartProperties);
			
			// Add loading state
			var $button = $('.prodMain__buyButton--buy');
			var originalText = $button.text();
			$button.text('Adding...').prop('disabled', true);
			
			CartJS.addItem(
				variantId,
				qty,
				cartProperties,
				{
					success: function (data, textStatus, jqXHR) {
						console.log('✅ Product added to cart successfully', data);
						$('.prodMain__buyButton--buy').text('Added To Cart');
						updateCartBubble();
						
						// RESTORE ORIGINAL REDIRECT BEHAVIOR
						window.location.href = '/cart';
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log('❌ Error adding to cart:', errorThrown);
						console.log('Error details:', jqXHR.responseText);
						
						// Reset button on error
						$button.text('Error - Try Again').prop('disabled', false);
						setTimeout(function() {
							$button.text(originalText);
						}, 3000);
					}
				}
			);
		}

		$('.prodMain__buyButton--buy').on('click', function () {
			prodAddToCart();
		});

		$('.nav__cartBubbleNumber').each(function () {
			var count = CartJS.cart.item_count;
			if (count > 0) {
				$(this).parent().show();
				$(this).text(count);
			}
		});

		function updateCartBubble() {
			var count = CartJS.cart.item_count;
			var countCheck = setInterval(function () {
				console.log(count + ' vs ' + CartJS.cart.item_count);
				if (CartJS.cart.item_count != count) {
					$('.nav__cartBubbleNumber').each(function () {
						if (CartJS.cart.item_count > 0) {
							$(this).parent().show();
							$(this).text(CartJS.cart.item_count);
						} else {
							$(this).parent().hide();
							$(this).text(CartJS.cart.item_count);
						}
					});
					clearInterval(countCheck);
				}
			}, 100);
		}

		//mobile collection code --------------------------------------------------------

		$('[mobile-selector-category]').on('click', function () {
			$('[subnav="category"]').show();
			$('.navMob').fadeIn();
		});

		$('[mobile-selector-occasion]').on('click', function () {
			$('[subnav="occasion"]').show();
			$('.navMob').fadeIn();
		});

		//slick sliders code -------------------------------------------------------------

		$('.prodMain__thumb').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 6,
			asNavFor: '.prodMain__preview',
			vertical: true,
			focusOnSelect: true,
		});

		$('.prodMain__preview').slick({
			dots: false,
			arrows: false,
			infinite: true,
			fade: true,
			slidesToShow: 1,
			asNavFor: '.prodMain__thumb',
		});

		$('.prodMain__prevButon').on('click', function () {
			$('.prodMain__preview').slick('slickPrev');
		});

		$('.prodMain__nextButton').on('click', function () {
			$('.prodMain__preview').slick('slickNext');
		});

		$('.companyValues__slider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 1,
		});

		$('.companyValues__dualImage').slick({
			dots: false,
			arrows: false,
			fade: true,
			infinite: true,
			slidesToShow: 1,
		});

		$('.companyValues__prevButton').on('click', function () {
			$('.companyValues__slider').slick('slickPrev');
			$('.companyValues__dualImage').slick('slickPrev');
		});

		$('.companyValues__nextButton').on('click', function () {
			$('.companyValues__slider').slick('slickNext');
			$('.companyValues__dualImage').slick('slickNext');
		});

		$('.homeCollection__textSlider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 1,
		});

		$('.homeCollection__dualImage').slick({
			dots: false,
			arrows: false,
			infinite: true,
			fade: true,
			slidesToShow: 1,
		});

		$('.homeCollection__backArrow').on('click', function () {
			$('.homeCollection__textSlider').slick('slickPrev');
			$('.homeCollection__dualImage').slick('slickPrev');
		});

		$('.homeCollection__forwardArrow').on('click', function () {
			$('.homeCollection__textSlider').slick('slickNext');
			$('.homeCollection__dualImage').slick('slickNext');
		});

		$('.homeProcess__textSlider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 1,
		});

		var slidePage = 1;

		$('.homeProcess__backArrow').on('click', function () {
			$('.homeProcess__textSlider').slick('slickPrev');
			if (slidePage > 1) {
				slidePage--;
			} else {
				slidePage = parseInt(
					$('.homeProcess__finalSlide').text().trim()
				);
			}
			$('.homeProcess__currentSlide').text(slidePage);
		});

		$('.homeProcess__forwardArrow').on('click', function () {
			$('.homeProcess__textSlider').slick('slickNext');
			if (
				slidePage <
				parseInt($('.homeProcess__finalSlide').text().trim())
			) {
				slidePage++;
			} else {
				slidePage = 1;
			}
			$('.homeProcess__currentSlide').text(slidePage);
		});

		if ($(window).width() > 900) {
			$('.homeProcess__textSlider').hide();
		}
		$(window).on('resize', function () {
			if ($(window).width() > 900) {
				$('.homeProcess__textSlider').hide();
			} else {
				$('.homeProcess__textSlider').show();
			}
		});

		$('.homeStories__textSlider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 1,
		});

		$('.homeStories__trippleImageSlider').slick({
			dots: false,
			arrows: false,
			fade: true,
			infinite: true,
			slidesToShow: 1,
		});

		$('.homeStories__backArrow').on('click', function () {
			$('.homeStories__textSlider').slick('slickPrev');
			$('.homeStories__trippleImageSlider').slick('slickPrev');
		});

		$('.homeStories__forwardArrow').on('click', function () {
			$('.homeStories__textSlider').slick('slickNext');
			$('.homeStories__trippleImageSlider').slick('slickNext');
		});

		$('.legacyCharmProcess__textSlider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 1,
		});

		var slidePageLegacy = 1;

		$('.legacyCharmProcess__backArrow').on('click', function () {
			$('.legacyCharmProcess__textSlider').slick('slickPrev');
			if (slidePageLegacy > 1) {
				slidePageLegacy--;
			} else {
				slidePageLegacy = parseInt(
					$('.legacyCharmProcess__finalSlide').text().trim()
				);
			}
			$('.legacyCharmProcess__currentSlide').text(slidePageLegacy);
		});

		$('.legacyCharmProcess__forwardArrow').on('click', function () {
			$('.legacyCharmProcess__textSlider').slick('slickNext');
			if (
				slidePageLegacy <
				parseInt($('.legacyCharmProcess__finalSlide').text().trim())
			) {
				slidePageLegacy++;
			} else {
				slidePageLegacy = 1;
			}
			$('.legacyCharmProcess__currentSlide').text(slidePageLegacy);
		});

		if ($(window).width() > 900) {
			$('.legacyCharmProcess__textSlider').hide();
		}
		$(window).on('resize', function () {
			if ($(window).width() > 900) {
				$('.legacyCharmProcess__textSlider').hide();
			} else {
				$('.legacyCharmProcess__textSlider').show();
			}
		});

		$('.peopleSlider__slider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 5,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});

		$('.peopleSlider__backArrow').on('click', function () {
			$('.peopleSlider__slider').slick('slickPrev');
		});

		$('.peopleSlider__forwardArrow').on('click', function () {
			$('.peopleSlider__slider').slick('slickNext');
		});

		$('.prodOther__slider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 4,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});

		$('.prodOther__prevButon').on('click', function () {
			$('.prodOther__slider').slick('slickPrev');
		});

		$('.prodOther__nextButton').on('click', function () {
			$('.prodOther__slider').slick('slickNext');
		});

		$('.resultOne__slider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 3,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});

		$('.resultOne__prevButon').on('click', function () {
			$('.resultOne__slider').slick('slickPrev');
		});

		$('.resultOne__nextButton').on('click', function () {
			$('.resultOne__slider').slick('slickNext');
		});

		$('.resultTwo__slider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 4,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});

		$('.resultTwo__prevButon').on('click', function () {
			$('.resultTwo__slider').slick('slickPrev');
		});

		$('.resultTwo__nextButton').on('click', function () {
			$('.resultTwo__slider').slick('slickNext');
		});

		//buyflow codes ---------------------------------------------------------------------

		if ($('.customer-logged-in').length) {
			$('.boxMain__button--loggedOut').hide();
			$('.boxMain__button--loggedIn').show();
		}

		$('.boxMain__button--loggedIn').on('click', function () {
			var variantId = $('.boxMain__button').attr('variant-id') * 1;
			var alreadyInCart = false;
			for (i = 0; i < CartJS.cart.items.length; i++) {
				if (CartJS.cart.items[i].variant_id == variantId) {
					alreadyInCart = true;
				}
			}
			if (alreadyInCart == false) {
				$('.boxForm').submit();
			} else {
				$('.boxMain__button--loggedIn').text('In Cart');
				$('.boxMain__button--loggedIn')
					.text('In Cart')
					.prop('disabled', true);
			}
		});

		$('.prodMain__buyButton--loggedOut').on('click', function () {
			$('.prodPop').fadeIn();
		});

		$('.prodPop__overlay, .prodPop__exit').on('click', function () {
			$('.prodPop').fadeOut();
		});

		$('.boxMain__button--loggedOut').on('click', function () {
			$('.boxPop').fadeIn();
		});

		$('.boxPop__overlay, .boxPop__exit').on('click', function () {
			$('.boxPop').fadeOut();
		});

		function boxAddToCart() {
			var variantId = $('.boxMain__button').attr('variant-id') * 1;
			var qty = 1;
			var alreadyInCart = false;
			for (i = 0; i < CartJS.cart.items.length; i++) {
				if (CartJS.cart.items[i].variant_id == variantId) {
					alreadyInCart = true;
				}
			}
			if (alreadyInCart == false) {
				$('.boxForm').submit();
			} else {
				$('.boxMain__button').text('In Cart');
				$('.boxMain__button').text('In Cart').prop('disabled', true);
			}
		}

		var alreadyInCart = false;
		for (i = 0; i < CartJS.cart.items.length; i++) {
			if (
				CartJS.cart.items[i].variant_id ==
				$('.boxMain__button').attr('variant-id') * 1
			) {
				alreadyInCart = true;
			}
		}
		if (alreadyInCart == true) {
			$('.boxMain__button').text('In Cart').prop('disabled', true);
		}

		var alreadyInCartResults = false;
		for (i = 0; i < CartJS.cart.items.length; i++) {
			if (
				CartJS.cart.items[i].variant_id ==
				$('.resultThree__buy').attr('variant-id') * 1
			) {
				alreadyInCartResults = true;
			}
		}
		if (alreadyInCartResults == true) {
			$('.resultThree__buy').text('In Cart').prop('disabled', true);
		}

		function resultsAddToCart() {
			var variantId = $('.resultThree__buy').attr('variant-id') * 1;
			var qty = 1;
			var alreadyInCart = false;
			for (i = 0; i < CartJS.cart.items.length; i++) {
				if (CartJS.cart.items[i].variant_id == variantId) {
					alreadyInCartResults = true;
				}
			}
			if (alreadyInCartResults == false) {
				CartJS.addItem(
					variantId,
					qty,
					{
						Answers: userAnswers,
						Story: userStory,
						Image: userImage,
					},
					{
						success: function (data, textStatus, jqXHR) {
							console.log('Product added to cart successfully');
							$('.resultThree__buy').text('In Cart');
							$('.resultThree__buy')
								.text('In Cart')
								.prop('disabled', true);
							updateCartBubble();
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					}
				);
			} else {
				$('.resultThree__buy').text('In Cart');
				$('.resultThree__buy').text('In Cart').prop('disabled', true);
			}
		}

		$('.resultThree__buy').on('click', function () {
			resultsAddToCart();
		});

		//account creation ------------------------------------------------------------------

		$('.boxPop__button').click(function (event) {
			event.preventDefault();
			var email = $('.inputWrapper--email input').val();
			var psw = $('.inputWrapper--password input').val();
			var pswVerify = $('.inputWrapper--validate input').val();
			if (email.search('@') != -1) {
				if (psw == pswVerify) {
					createAccountBoxPage(email, psw);
					boxAddToCart();
					$('.boxPop__submitting').fadeIn();
				} else {
					$('.boxPop__errors').text('Passwords do not match');
				}
			} else {
				$('.boxPop__errors').text('Please Enter a valid email address');
			}
		});

		$('.quizControls__viewResults').click(function (event) {
			event.preventDefault();
			var email = $('.inputWrapper--email input').val();
			var psw = $('.inputWrapper--password input').val();
			var pswVerify = $('.inputWrapper--validate input').val();

			var answerArray = [];

			$('.quizAnswer--active').each(function () {
				var thisAnswer = $(this).attr('answer');
				answerArray.push(thisAnswer);
			});

			var allAnswerArray = [];

			$('.quiz__slide').each(function () {
				if (
					$(this).attr('quiz-slide') != '1' &&
					$(this).attr('quiz-slide') != '2' &&
					$(this).attr('quiz-slide') != '10' &&
					$(this).attr('quiz-slide') != '11' &&
					$(this).attr('quiz-slide') != '12'
				) {
					if ($(this).find('.quizAnswer--active').length > 0) {
						var thisAnswer = '';
						$(this)
							.find('.quizAnswer--active')
							.each(function () {
								thisAnswer += $(this).attr('answer');
							});
						allAnswerArray.push(thisAnswer);
					} else {
						allAnswerArray.push('skipped');
					}
				}
			});

			var answerString = answerArray.toString();
			var allAnswerString = allAnswerArray.toString();
			var story = $('.quiz__storyTextField').val().replace(/'/g, '');
			var image = $('.quiz__uploadButton').attr('data-image-url');
			var name = $('.quiz__nameDisplayText--name')
				.text()
				.replace(/'/g, '');

			if (email.search('@') != -1) {
				if (psw == pswVerify) {
					createAccountQuiz(
						email,
						psw,
						answerString,
						allAnswerString,
						story,
						image,
						name
					);
					$('.quiz__formSubmitting').fadeIn();
				} else {
					$('.boxPop__errors').text('Passwords do not match');
				}
			} else {
				$('.boxPop__errors').text('Please Enter a valid email address');
			}

			var settings = getKlaviyoSettings(email, allAnswerString, name);
			$.ajax(settings).done(function (response) {
				console.log(response);
			});
		});

		$('.quizControls__bypass').click(function (event) {
			event.preventDefault();

			var answerArray = [];

			$('.quizAnswer--active').each(function () {
				var thisAnswer = $(this).attr('answer');
				answerArray.push(thisAnswer);
			});

			var allAnswerArray = [];

			$('.quiz__slide').each(function () {
				if (
					$(this).attr('quiz-slide') != '1' &&
					$(this).attr('quiz-slide') != '2' &&
					$(this).attr('quiz-slide') != '10' &&
					$(this).attr('quiz-slide') != '11' &&
					$(this).attr('quiz-slide') != '12'
				) {
					if ($(this).find('.quizAnswer--active').length > 0) {
						var thisAnswer = '';
						$(this)
							.find('.quizAnswer--active')
							.each(function () {
								thisAnswer += $(this).attr('answer');
							});
						allAnswerArray.push(thisAnswer);
					} else {
						allAnswerArray.push('skipped');
					}
				}
			});

			var answerString = answerArray.toString();
			var allAnswerString = allAnswerArray.toString();
			var story = $('.quiz__storyTextField').val().replace(/'/g, '');
			var image = $('.quiz__uploadButton').attr('data-image-url');
			var name = $('.quiz__nameDisplayText--name')
				.text()
				.replace(/'/g, '');

			localStorage.setItem('answers', answerString);
			localStorage.setItem('story', story);
			localStorage.setItem('image', image);

			var email = $('body').attr('customer-email');

			var settings = getKlaviyoSettings(email, allAnswerString, name);
			$.ajax(settings).done(function (response) {
				console.log(response);
				window.location.href = '/pages/quiz-results';
			});
		});

		if ($('body').attr('customer-email').indexOf('@') > 0) {
			$('[quiz-slide="11"')
				.find('.quiz__storySuperTitle')
				.text('Hit the View Results button below.');
			$('[quiz-slide="11"').find('.quiz__formWrapper').hide();
		}

		function createAccountBoxPage(email, password) {
			var escapedData = {
				email: escape(email),
				password: escape(password).replace(/\+/g, '%2B'),
			};
			var data =
				'form_type=create_customer&utf8=%E2%9C%93&customer%5Bemail%5D=';
			data += escapedData.email;
			data += '&customer%5Bpassword%5D=';
			data += escapedData.password;
			jQuery
				.post('/account', data)
				.done(function (response) {
					var logErrors = jQuery(response).find('.errors').text();
					if (logErrors != '' && logErrors != 'undefined') {
						console.log(logErrors);
						$('.boxPop__errors').text(logErrors);
						$('.boxPop__submitting').fadeOut();
					} else {
						console.log('success!');
						LoginAccount(email, password);
						$('.boxPop__submitting').fadeOut();
						$('.boxPop').fadeOut();
					}
				})
				.fail(function () {
					console.log('error could not submit');
					$('.boxPop__submitting').fadeOut();
				});
			return false;
		}

		function getKlaviyoSettings(email, answers, name) {
			var answerArray = answers.split(',');

			var doc = {
				1: {
					a: '1950s or earliers',
					b: '1960s',
					c: '1970s',
					d: '1980s',
					e: '1990s',
					f: '2000s',
				},
				2: {
					a: 'Mermaid',
					b: 'Ball Gown',
					c: 'A-line',
					d: 'Slip',
					e: 'Empire',
					f: 'Trumpet',
				},
				3: {
					a: 'Covered Buttons',
					b: 'Sequins or Pearls',
					c: 'Oversized Bow',
					d: 'Lace Trim or Appliques',
					e: 'Fringe',
					f: 'Other',
				},
				4: {
					a: 'Knee Length or Shorter',
					b: 'Tea Length (Mid-calf)',
					c: 'Floor Length',
					d: 'Small Train (12 feet)',
					e: 'Long/Full Train (2+ feet)',
				},
				5: {
					a: 'Strapless',
					b: 'Short Sleeves',
					c: 'Long Sleeves - 3/4 Length',
					d: 'Pouf Sleeves',
				},
				6: {
					a: 'Wedding',
					b: 'Anniversary',
					c: 'New Baby',
					d: 'Religious Event',
					e: 'Holiday',
					f: 'Memorial',
				},
				7: {
					a: 'Partner/Spouse',
					b: 'Daughter(s)',
					c: 'Son(s)',
					d: 'Grandchildren',
					e: 'Myself',
					f: 'Friends',
				},
			};

			var newAnswers = answerArray.map(function (answer) {
				var questionAnswers = answer.match(/.{1,2}/g);
				var questionAnswersValue = '';
				for (var j = 0; j < questionAnswers.length; j++) {
					var questionNumber = questionAnswers[j].substring(0, 1);
					var answerLetter = questionAnswers[j].substring(1, 2);
					questionAnswersValue += doc[questionNumber][answerLetter];
					if (j !== questionAnswers.length - 1) {
						questionAnswersValue += ', ';
					}
				}
				return questionAnswersValue;
			});
			console.log(newAnswers);

			var settings = {
				async: true,
				crossDomain: true,
				url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
				method: 'POST',
				headers: {
					'content-type': 'application/x-www-form-urlencoded',
					'cache-control': 'no-cache',
				},
				data: {
					g: 'SagDzw', // replace LIST_ID with id of list to be subscribed
					email: email,
					$fields:
						'$source, $first_name, $answer_one, $answer_two, $answer_three, $answer_four, $answer_five, $answer_six, $answer_seven',
					$source: 'Quiz Submission',
					$first_name: name,
					$answer_one: newAnswers[0],
					$answer_two: newAnswers[1],
					$answer_three: newAnswers[2],
					$answer_four: newAnswers[3],
					$answer_five: newAnswers[4],
					$answer_six: newAnswers[5],
					$answer_seven: newAnswers[6],
				},
			};
			return settings;
		}

		function createAccountQuiz(
			email,
			password,
			answers,
			allAnswers,
			story,
			image,
			name
		) {
			var escapedData = {
				email: escape(email),
				password: escape(password).replace(/\+/g, '%2B'),
			};
			var data =
				'form_type=create_customer&utf8=%E2%9C%93&customer%5Bemail%5D=';
			data += escapedData.email;
			data += '&customer%5Bpassword%5D=';
			data += escapedData.password;
			jQuery
				.post('/account', data)
				.done(function (response) {
					var logErrors = jQuery(response).find('.errors').text();
					if (logErrors != '' && logErrors != 'undefined') {
						console.log(logErrors);
						$('.boxPop__errors').text(logErrors);
						$('.quiz__formSubmitting').fadeOut();
					} else {
						console.log('success!');
						LoginAccountQuiz(email, password);
						$('.quiz__formSubmitting').fadeOut();
						localStorage.setItem('answers', answers);
						localStorage.setItem('story', story);
						localStorage.setItem('image', image);
					}
				})
				.fail(function () {
					console.log('error could not submit');
					$('.quiz__formSubmitting').fadeOut();
				});

			return false;
		}

		function LoginAccount(email, password) {
			var escapedData = {
				email: escape(email),
				password: escape(password).replace(/\+/g, '%2B'),
			};
			var data = 'form_type=login&utf8=%E2%9C%93&customer%5Bemail%5D=';
			data += escapedData.email;
			data += '&customer%5Bpassword%5D=';
			data += escapedData.password;
			jQuery
				.post('/account/login', data)
				.done(function (response) {
					var logErrors = jQuery(response).find('.errors').text();
					if (logErrors != '' && logErrors != 'undefined') {
						console.log(logErrors);
					} else {
						console.log('success!');
					}
				})
				.fail(function () {
					console.log('error could not submit');
				});
			return false;
		}

		function LoginAccountQuiz(email, password) {
			var escapedData = {
				email: escape(email),
				password: escape(password).replace(/\+/g, '%2B'),
			};
			var data = 'form_type=login&utf8=%E2%9C%93&customer%5Bemail%5D=';
			data += escapedData.email;
			data += '&customer%5Bpassword%5D=';
			data += escapedData.password;
			jQuery
				.post('/account/login', data)
				.done(function (response) {
					var logErrors = jQuery(response).find('.errors').text();
					if (logErrors != '' && logErrors != 'undefined') {
						console.log(logErrors);
					} else {
						console.log('success!');
						window.location.href = '/pages/quiz-results';
					}
				})
				.fail(function () {
					console.log('error could not submit');
				});
			return false;
		}

		if ($('.customer-logged-in').length > 0) {
			$('.prodMain__buyButton--loggedOut').hide();
			$('.prodMain__buyButton--loggedIn').show();
		}

		if ($('.box-purchased').length) {
			$('.prodMain__buyButton--loggedOut').hide();
			$('.prodMain__buyButton--loggedIn').hide();
			$('.prodMain__buyButton--buy').show();
		}

		$('.nav__login, .navMob__bottomLink--login').on('click', function () {
			$('.loginModal').fadeIn();
		});

		$('.loginModal__closeButton, .loginModal__overlay').on(
			'click',
			function () {
				$('.loginModal').fadeOut();
			}
		);

		function LoginAccountPopup(email, password) {
			var escapedData = {
				email: escape(email),
				password: escape(password).replace(/\+/g, '%2B'),
			};
			var data = 'form_type=login&utf8=%E2%9C%93&customer%5Bemail%5D=';
			data += escapedData.email;
			data += '&customer%5Bpassword%5D=';
			data += escapedData.password;
			jQuery
				.post('/account/login', data)
				.done(function (response) {
					var logErrors = jQuery(response).find('.errors').text();
					if (logErrors != '' && logErrors != 'undefined') {
						console.log(logErrors);
						$('.loginModal__errors').text(logErrors);
					} else {
						console.log('success!');
						window.location.href = '/account';
					}
				})
				.fail(function () {
					console.log('error could not submit');
				});
			return false;
		}

		$('.loginModal__button').on('click', function () {
			var email = $('.loginModal .inputWrapper--email input').val();
			var password = $('.loginModal .inputWrapper--password input').val();
			LoginAccountPopup(email, password);
		});

		if ($('.upload-lift').length > 0) {
			document
				.querySelector('.upload-lift')
				.addEventListener('upload:added', function (e) {
					var file = e.detail;
					console.log('new file: ' + file.url);
					$('.quiz__uploadButton').attr('data-image-url', file.url);
					$('.quiz__uploadButtonIcon').attr('src', file.url);
					$('.quiz__uploadText').text('Upload Successful');
				});
		}

		$('.quiz__uploadButton').on('click', function () {
			$('.upload-lift label').click();
		});

		// wishlist functionality --------------------------------------------------------------------

		function connectWishlistAccount() {
			window._swat.evtLayer.addEventListener(
				window._swat.JSEvents.customerInfoRefreshed,
				function (evt) {
					window._swat.authCheck(function (shopperContext) {});
				}
			);

			if ($('.customer-logged-in').length) {
				window._swat.saveShopperContext(
					$('.customer-logged-in').attr('customer-email'),
					{},
					function () {
						console.log('wishlist context success');
					},
					function () {
						console.log('error with wishlist context');
					}
				);
			}
		}

		function addToWishList(
			variantID,
			productID,
			productURL,
			variantImage,
			price,
			stock,
			qty
		) {
			window._swat.addToWishList(
				{
					epi: variantID * 1,
					du: productURL,
					empi: productID * 1,
					iu: variantImage,
					pr: price,
					et: 4,
					stk: stock * 1,
					qty: qty,
				},
				function (r) {
					console.log(r);
					console.log('Added to wishlist');
					connectWishlistAccount();
					updateWishlistReady = true;
				}
			);
		}

		function removeFromWishList(
			variantID,
			productID,
			productURL,
			variantImage,
			price,
			stock,
			qty
		) {
			window._swat.removeFromWishList(
				{
					epi: variantID * 1,
					du: productURL,
					empi: productID * 1,
					iu: variantImage,
					pr: price,
					et: 4,
					stk: stock * 1,
					qty: qty,
				},
				function (r) {
					console.log(r);
					console.log('Removed from wishlist');
					updateWishlistReady = true;
					connectWishlistAccount();
				}
			);
		}

		function updateWishList(library, index, qty) {
			var translated = translateWishList(library);

			var variantID = translated[index].variant_id;
			var productID = translated[index].product_id;
			var productURL = translated[index].product_url;
			var variantImage = translated[index].variant_image;
			var price = translated[index].variant_price;
			var stock = translated[index].stock;
			var old_qty = translated[index].product_quantity;
			var new_qty = qty * 1;

			console.log(new_qty);
			window._swat.fetchLists({
				callbackFn: function (lists) {
					var listID = lists[0].id;
					var listItemMap = {
						epi: library[index].epi,
						empi: library[index].empi,
						du: library[index].du,
						qty: new_qty,
					};
					window._swat.updateListItem(
						listID,
						listItemMap,
						function (updatedListItem) {
							console.log('success');
							updateWishlistReady = true;
						},
						function (xhrObj) {
							console.log(xhrObj);
						}
					);
				},
				errorFn: function (xhrObj) {
					// something went wrong
				},
			});
		}

		function translateWishList(data) {
			var betterArray = [];
			for (i = 0; i < data.length; i++) {
				var betterJSON = {
					product_title: data[i].dt,
					product_url: data[i].du,
					product_id: data[i].empi,
					variant_id: data[i].epi,
					variant_image: data[i].iu,
					variant_price: data[i].pr,
					stock: data[i].stk,
					product_quantity: data[i].qty,
				};
				if (data[i].et == 4) {
					betterArray.push(betterJSON);
				}
			}
			return betterArray;
		}

		function checkAgainstWishlist(wishlistData, productId) {
			var wishlist = translateWishList(wishlistData);
			var match = false;
			for (i = 0; i < wishlist.length; i++) {
				if (wishlist[i].product_id == productId) {
					match = true;
				} else {
				}
			}
			return match;
		}

		$('.prodMain__buyButton--loggedIn').on('click', function () {
			var selected = $('.prodMain__hiddenSelector').children(':selected');
			if ($(this).text() == 'Remove From Design Plan') {
				removeFromWishList(
					selected.attr('variant-id'),
					selected.attr('product-id'),
					selected.attr('product-url'),
					selected.attr('variant-image'),
					selected.attr('chopped-price'),
					selected.attr('variant-stock'),
					$('.prodMain__qty').text().trim() * 1
				);
				$(this).text('Add To Design Plan');
			} else {
				addToWishList(
					selected.attr('variant-id'),
					selected.attr('product-id'),
					selected.attr('product-url'),
					selected.attr('variant-image'),
					selected.attr('chopped-price'),
					selected.attr('variant-stock'),
					$('.prodMain__qty').text().trim() * 1
				);
				$(this).text('Remove From Design Plan');
			}
		});

		$('.productCard__wishlistButton').on('click', function (e) {
			e.preventDefault();
			if ($(this).hasClass('productCard__wishlistButton--in')) {
				removeFromWishList(
					$(this).attr('variant-id'),
					$(this).attr('product-id'),
					$(this).attr('product-url'),
					$(this).attr('variant-image'),
					$(this).attr('price'),
					$(this).attr('stock'),
					$(this).attr('qty').trim() * 1
				);
				$(this).removeClass('productCard__wishlistButton--in');
			} else {
				addToWishList(
					$(this).attr('variant-id'),
					$(this).attr('product-id'),
					$(this).attr('product-url'),
					$(this).attr('variant-image'),
					$(this).attr('price'),
					$(this).attr('stock'),
					$(this).attr('qty').trim() * 1
				);
				$(this).addClass('productCard__wishlistButton--in');
			}
		});

		$('.accountHome__sharePopup').on('click', function () {
			$('.accountSharePopup').fadeIn();
		});
		$('.accountSharePopup__overlay').on('click', function () {
			$('.accountSharePopup').fadeOut();
		});

		$('.accountSharePopup__close').on('click', function () {
			$('.accountSharePopup').fadeOut();
		});

		function shareWishlist(email) {
			var name = $('body').attr('customer-email');

			window._swat.sendListViaEmail(
				{
					toEmailId: email,
					fromName: name,
					note: 'My Unbox The Dress Design Plan.',
					lid: null, // null when multiple list is not enabled
					cprops: {}, // custom props for the share, future usage
				},
				function (r) {
					console.log('Email sent!');
					$('.accountSharePopup__button').text('Design Plan Sent!');
				},
				function (r) {
					console.log('Email failed!');
				}
			);
		}

		$('.accountSharePopup__button').on('click', function () {
			var email = $('.accountSharePopup__inner input').val();
			shareWishlist(email);
		});

		function swymCallbackFn(swat) {
			var wishlistLoaded = setInterval(function () {
				window._swat.fetch(function (r) {
					if (r.length > 0) {
						clearInterval(wishlistLoaded);

						console.log(r);
						console.log(translateWishList(r));

						connectWishlistAccount();

						var renderList = translateWishList(r);
						var updateWishlistReady = true;

						$('.prodMain__buyButton--loggedIn').each(function () {
							console.log('loop start');
							var thisProdId =
								$('.prodMain__hiddenSelector')
									.children(':selected')
									.attr('product-id') * 1;
							if (checkAgainstWishlist(r, thisProdId)) {
								$(this).text('Remove From Design Plan');
								console.log('Already in wishlist');
							}
						});

						$('.productCard__wishlistButton').each(function () {
							var thisProdId = $(this).attr('product-id') * 1;
							if (checkAgainstWishlist(r, thisProdId)) {
								$(this).addClass(
									'productCard__wishlistButton--in'
								);
							}
						});

						if (
							$('#shopify-section-accountDesignPlan').length >= 1
						) {
							console.log('correct page');
							var bucket = $('.accountHome__bucket');
							for (i = 0; i < renderList.length; i++) {
								console.log(i);
								var card = '';
								card +=
									'<div class="planCard" data-iteration="' +
									i +
									'">';
								card += '<div class="planCard__inner">';

								card += '<div class="planCard__imageWrapper">';
								card +=
									'<img class="planCard__image" src="' +
									renderList[i].variant_image +
									'" alt="' +
									renderList[i].product_title +
									'">';
								card += '</div>';

								card += '<div class="planCard__titleWrapper">';
								card += '<div class="planCard__title">';
								card += renderList[i].product_title;
								card += '</div>';
								card += '</div>';

								card += '<div class="planCard__buttonWrapper">';
								card += '<div class="planCard__qtyWrapper">';
								card +=
									'<button class="planCard__qtyMinus">-</button>';
								card += '<div class="planCard__qty">';
								card += renderList[i].product_quantity;
								card += '</div>';
								card +=
									'<button class="planCard__qtyPlus">+</button>';
								card += '</div>';
								card +=
									'<button class="planCard__addToCart" data-id="' +
									renderList[i].variant_id +
									'">';
								card += 'Add To Cart';
								card += '</button>';
								card +=
									'<a class="planCard__goToCart" href="/cart" style="display:none;">';
								card += 'View In Cart';
								card += '</a>';
								card += '<button class="planCard__remove">';
								card +=
									'<img class="planCard__removeIcon" src="https://cdn.shopify.com/s/files/1/1586/7217/files/Union.png?v=1648318578" alt="remove icon">';
								card += '</button>';
								card += '</div>';

								card += '</div>';
								card += '</div>';
								bucket.html(bucket.html() + card);
							}

							// button binds here
							$('.planCard__qtyMinus').on('click', function () {
								if (updateWishlistReady == true) {
									var index = $(this)
										.parent()
										.parent()
										.parent()
										.parent()
										.attr('data-iteration');
									var currentQty =
										$(this)
											.parent()
											.find('.planCard__qty')
											.text()
											.trim() * 1;
									if (currentQty > 1) {
										updateWishlistReady = false;
										var newQty = currentQty - 1;
										$(this)
											.parent()
											.find('.planCard__qty')
											.text(newQty);
										updateWishList(r, index, newQty);
									}
								}
							});

							$('.planCard__qtyPlus').on('click', function () {
								if (updateWishlistReady == true) {
									var index = $(this)
										.parent()
										.parent()
										.parent()
										.parent()
										.attr('data-iteration');
									var currentQty =
										$(this)
											.parent()
											.find('.planCard__qty')
											.text()
											.trim() * 1;
									updateWishlistReady = false;
									var newQty = currentQty + 1;
									$(this)
										.parent()
										.find('.planCard__qty')
										.text(newQty);
									updateWishList(r, index, newQty);
								}
							});

							$('.planCard__remove').on('click', function () {
								var index =
									$(this)
										.parent()
										.parent()
										.parent()
										.attr('data-iteration') * 1;
								var currentQty =
									$(this)
										.parent()
										.find('.planCard__qty')
										.text()
										.trim() * 1;
								updateWishlistReady = false;

								console.log(index);
								console.log(renderList[index]);

								var variantID = renderList[index].variant_id;
								var productID = renderList[index].product_id;
								var productURL = renderList[index].product_url;
								var variantImage =
									renderList[index].variant_image;
								var price = renderList[index].variant_price;
								var stock = renderList[index].stock;
								var qty = renderList[index].product_quantity;

								removeFromWishList(
									variantID,
									productID,
									productURL,
									variantImage,
									price,
									stock,
									qty
								);
								$(this).parent().parent().parent().slideUp();

								connectWishlistAccount();
							});

							$('.planCard').each(function () {
								var variantId =
									$(this)
										.find('.planCard__addToCart')
										.attr('data-id') * 1;
								for (i = 0; i < CartJS.cart.items.length; i++) {
									if (
										CartJS.cart.items[i].variant_id ==
										variantId
									) {
										$(this)
											.find('.planCard__addToCart')
											.hide();
										$(this)
											.find('.planCard__remove')
											.hide();
										$(this)
											.find('.planCard__goToCart')
											.show();
									}
								}
							});

							$('.planCard__addToCart').on('click', function () {
								var variantId = $(this).attr('data-id') * 1;
								CartJS.addItem(
									variantId,
									1,
									{},
									{
										success: function (
											data,
											textStatus,
											jqXHR
										) {
											console.log(
												'Product added to cart successfully'
											);
											updateCartBubble();
										},
										error: function (
											jqXHR,
											textStatus,
											errorThrown
										) {
											console.log(
												'Error: ' + errorThrown + '!'
											);
										},
									}
								);
								$(this)
									.parent()
									.find('.planCard__addToCart')
									.hide();
								$(this)
									.parent()
									.find('.planCard__remove')
									.hide();
								$(this)
									.parent()
									.find('.planCard__goToCart')
									.show();
							});
						}
					}
				});
			}, 100);
		}
		if (!window.SwymCallbacks) {
			window.SwymCallbacks = [];
		}
		window.SwymCallbacks.push(swymCallbackFn);

		console.log('new page');

		// Quiz -----------------------------------------------------------------------------

		function resizeInput() {
			var placeholder = $(this).attr('placeholder').length - 2;
			var value = $(this).val().length;
			if (placeholder < 0) {
				placeholder = 0;
			}
			if (value < 0) {
				value = 0;
			}
			if (value == 0) {
				$(this).attr('size', placeholder);
			} else {
				$(this).attr('size', value);
			}
		}

		$('.quiz__slideNameInput').keyup(resizeInput).each(resizeInput);
		$('.quiz__slideNameInput').focus().select();

		$(
			'.quizControls__viewResults, .quizControls__skip, .quizControls__why, .quizControls__bypass'
		).hide();

		var quizStep = 1;
		var name = '';

		$('.quizNav__logo').on('click', function () {
			$('.quizPopup').fadeIn();
		});

		$('.quizPopup__modalX, .quizPopup__continue, .quizPopup__overlay').on(
			'click',
			function () {
				$('.quizPopup').fadeOut();
			}
		);

		if ($('.customer-logged-in').length > 0) {
			$('.quiz__slideNameInput').val(localStorage.getItem('name'));
		}

		function changeStep(step) {
			console.log(step);
			$('.quiz__sled').attr(
				'style',
				'left:calc(-1 * ((1200vw / 11) * (' + step + ' - 1)));'
			);
			$('.quizNav__loadingBar').attr(
				'style',
				'width: calc((100% / 11) * ' + step + ');'
			);

			if (quizStep == 1) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').hide();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			if (quizStep == 2) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').hide();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();

				$('.quiz__nameDisplayText--name').text(
					$('.quiz__slideNameInput').val()
				);
				localStorage.setItem('name', $('.quiz__slideNameInput').val());
			}
			if (quizStep == 3) {
				$('.quizControls__why').show();
				$('.quizControls__skip').show();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			if (quizStep == 4) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').show();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			if (quizStep == 5) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').show();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			if (quizStep == 6) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').show();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			if (quizStep == 7) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').show();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			if (quizStep == 8) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').show();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			if (quizStep == 9) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').show();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			if (quizStep == 10) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').show();
				$('.quizControls__continueButton').show();
				$('.quizControls__viewResults').hide();
				$('.quizControls__bypass').hide();
			}
			// if (quizStep == 11){
			//   $('.quizControls__why').hide();
			//   $('.quizControls__skip').show();
			//   $('.quizControls__continueButton').show();
			//   $('.quizControls__viewResults').hide();
			//   $('.quizControls__bypass').hide();
			//   if ($('.customer-logged-in').length){
			//     $('.quizControls__bypass').show();
			//     $('.quizControls__continueButton').hide();
			//     $('.quizControls__skip').hide();
			//   }
			// }
			if (quizStep == 11) {
				$('.quizControls__why').hide();
				$('.quizControls__skip').hide();
				$('.quizControls__continueButton').hide();
				$('.quizControls__viewResults').show();
				$('.quizControls__bypass').hide();
				if ($('.customer-logged-in').length) {
					$('.quizControls__bypass').show();
					$('.quizControls__continueButton').hide();
					$('.quizControls__viewResults').hide();
					$('.quizControls__skip').hide();
				}
			}
		}

		$('.quizNav__back').on('click', function () {
			if (quizStep == 1) {
				$('.quizPopup').fadeIn();
			} else {
				quizStep -= 1;
				changeStep(quizStep);
			}
		});

		$('.quiz__slideNameInput').on('click', function () {
			$(this).removeClass('quiz__slideNameInput--error');
		});

		$('.quizAnswer').on('click', function () {
			if (
				quizStep == 3 ||
				quizStep == 4 ||
				quizStep == 6 ||
				quizStep == 7
			) {
				if ($(this).hasClass('quizAnswer--active')) {
					$(this).removeClass('quizAnswer--active');
				} else {
					$(this)
						.parent()
						.find('.quizAnswer')
						.removeClass('quizAnswer--active');
					$(this).addClass('quizAnswer--active');
				}
			} else {
				if ($(this).hasClass('quizAnswer--active')) {
					$(this).removeClass('quizAnswer--active');
				} else {
					$(this).addClass('quizAnswer--active');
				}
			}
		});

		$('.quizControls__skip').on('click', function () {
			quizStep += 1;
			changeStep(quizStep);
		});

		$('.quizControls__continueButton').on('click', function () {
			if (quizStep == 1) {
				if ($('.quiz__slideNameInput').val()) {
					quizStep += 1;
					changeStep(quizStep);
				} else {
					$('.quiz__slideNameInput').addClass(
						'quiz__slideNameInput--error'
					);
				}
			} else if (quizStep >= 3 && quizStep <= 9) {
				if (
					$('[quiz-slide="' + quizStep + '"]').find(
						'.quizAnswer--active'
					).length >= 1
				) {
					quizStep += 1;
					changeStep(quizStep);
				}
			} else if (quizStep == 10) {
				if ($.trim($('.quiz__storyTextField').val()) != '') {
					quizStep += 1;
					changeStep(quizStep);
				}
			} else if (quizStep == 11) {
				if ($('.quiz__uploadButton').attr('data-image-url') != '') {
					quizStep += 1;
					changeStep(quizStep);
				}
			} else {
				quizStep += 1;
				changeStep(quizStep);
			}
		});

		if (localStorage.getItem('name') != null) {
			var userName = localStorage.getItem('name');
		} else {
			var userName = false;
		}

		if (localStorage.getItem('answers') != null) {
			var userAnswers = localStorage.getItem('answers');
		} else {
			var userAnswers = false;
		}

		if (localStorage.getItem('story') != null) {
			var userStory = localStorage.getItem('story');
		} else {
			var userStory = false;
		}

		if (localStorage.getItem('image') != null) {
			var userImage = localStorage.getItem('image');
		} else {
			var userImage = false;
		}

		var keyObj = {
			'1a': '1950s or earlier',
			'1b': '1960',
			'1c': '1970',
			'1d': '1980',
			'1e': '1990',
			'1f': '2000',
			'2a': 'Mermaid',
			'2b': 'Ball Gown',
			'2c': 'A-line',
			'2d': 'Slip',
			'2e': 'Trumpet',
			'2f': 'Empire',
			'4a': 'Knee Length or Shorter',
			'4b': 'Tea Length (Mid-calf)',
			'4c': 'Floor Length',
			'4d': 'Small Train',
			'4e': 'Long / Full Train',
		};

		var possibleMatches = {
			'1a,2a,4a': '1',
			'1a,2a,4b': '1',
			'1a,2a,4c': '1',
			'1a,2a,4d': '1',
			'1a,2a,4e': '2',
			'1a,2b,4a': '1',
			'1a,2b,4b': '1',
			'1a,2b,4c': '1',
			'1a,2b,4d': '2',
			'1a,2b,4e': '2',
			'1a,2c,4a': '1',
			'1a,2c,4b': '1',
			'1a,2c,4c': '1',
			'1a,2c,4d': '1',
			'1a,2c,4e': '2',
			'1a,2d,4a': '1',
			'1a,2d,4b': '1',
			'1a,2d,4c': '1',
			'1a,2d,4d': '1',
			'1a,2d,4e': '1',
			'1a,2e,4a': '1',
			'1a,2e,4b': '1',
			'1a,2e,4c': '1',
			'1a,2e,4d': '1',
			'1a,2e,4e': '2',
			'1a,2f,4a': '1',
			'1a,2f,4b': '1',
			'1a,2f,4c': '1',
			'1a,2f,4d': '1',
			'1a,2f,4e': '2',
			'1b,2a,4a': '1',
			'1b,2a,4b': '1',
			'1b,2a,4c': '2',
			'1b,2a,4d': '2',
			'1b,2a,4e': '2',
			'1b,2b,4a': '2',
			'1b,2b,4b': '2',
			'1b,2b,4c': '3',
			'1b,2b,4d': '3',
			'1b,2b,4e': '3',
			'1b,2c,4a': '1',
			'1b,2c,4b': '1',
			'1b,2c,4c': '2',
			'1b,2c,4d': '2',
			'1b,2c,4e': '2',
			'1b,2d,4a': '1',
			'1b,2d,4b': '1',
			'1b,2d,4c': '2',
			'1b,2d,4d': '2',
			'1b,2d,4e': '2',
			'1b,2e,4a': '1',
			'1b,2e,4b': '1',
			'1b,2e,4c': '2',
			'1b,2e,4d': '2',
			'1b,2e,4e': '2',
			'1b,2f,4a': '1',
			'1b,2f,4b': '1',
			'1b,2f,4c': '2',
			'1b,2f,4d': '2',
			'1b,2f,4e': '2',
			'1c,2a,4a': '2',
			'1c,2a,4b': '2',
			'1c,2a,4c': '2',
			'1c,2a,4d': '2',
			'1c,2a,4e': '3',
			'1c,2b,4a': '2',
			'1c,2b,4b': '2',
			'1c,2b,4c': '3',
			'1c,2b,4d': '3',
			'1c,2b,4e': '3',
			'1c,2c,4a': '2',
			'1c,2c,4b': '2',
			'1c,2c,4c': '2',
			'1c,2c,4d': '3',
			'1c,2c,4e': '3',
			'1c,2d,4a': '2',
			'1c,2d,4b': '2',
			'1c,2d,4c': '2',
			'1c,2d,4d': '2',
			'1c,2d,4e': '3',
			'1c,2e,4a': '2',
			'1c,2e,4b': '2',
			'1c,2e,4c': '3',
			'1c,2e,4d': '3',
			'1c,2e,4e': '3',
			'1c,2f,4a': '2',
			'1c,2f,4b': '2',
			'1c,2f,4c': '3',
			'1c,2f,4d': '3',
			'1c,2f,4e': '3',
			'1d,2a,4a': '2',
			'1d,2a,4b': '2',
			'1d,2a,4c': '2',
			'1d,2a,4d': '2',
			'1d,2a,4e': '3',
			'1d,2b,4a': '2',
			'1d,2b,4b': '2',
			'1d,2b,4c': '4',
			'1d,2b,4d': '4',
			'1d,2b,4e': '5',
			'1d,2c,4a': '2',
			'1d,2c,4b': '2',
			'1d,2c,4c': '2',
			'1d,2c,4d': '3',
			'1d,2c,4e': '5',
			'1d,2d,4a': '2',
			'1d,2d,4b': '2',
			'1d,2d,4c': '2',
			'1d,2d,4d': '3',
			'1d,2d,4e': '3',
			'1d,2e,4a': '2',
			'1d,2e,4b': '2',
			'1d,2e,4c': '3',
			'1d,2e,4d': '3',
			'1d,2e,4e': '4',
			'1d,2f,4a': '2',
			'1d,2f,4b': '2',
			'1d,2f,4c': '3',
			'1d,2f,4d': '3',
			'1d,2f,4e': '4',
			'1e,2a,4a': '2',
			'1e,2a,4b': '2',
			'1e,2a,4c': '2',
			'1e,2a,4d': '2',
			'1e,2a,4e': '3',
			'1e,2b,4a': '2',
			'1e,2b,4b': '2',
			'1e,2b,4c': '4',
			'1e,2b,4d': '4',
			'1e,2b,4e': '5',
			'1e,2c,4a': '2',
			'1e,2c,4b': '2',
			'1e,2c,4c': '2',
			'1e,2c,4d': '3',
			'1e,2c,4e': '5',
			'1e,2d,4a': '1',
			'1e,2d,4b': '1',
			'1e,2d,4c': '2',
			'1e,2d,4d': '3',
			'1e,2d,4e': '3',
			'1e,2e,4a': '2',
			'1e,2e,4b': '2',
			'1e,2e,4c': '3',
			'1e,2e,4d': '3',
			'1e,2e,4e': '4',
			'1e,2f,4a': '2',
			'1e,2f,4b': '2',
			'1e,2f,4c': '3',
			'1e,2f,4d': '3',
			'1e,2f,4e': '4',
			'1f,2a,4a': '2',
			'1f,2a,4b': '2',
			'1f,2a,4c': '2',
			'1f,2a,4d': '3',
			'1f,2a,4e': '3',
			'1f,2b,4a': '2',
			'1f,2b,4b': '2',
			'1f,2b,4c': '4',
			'1f,2b,4d': '4',
			'1f,2b,4e': '5',
			'1f,2c,4a': '2',
			'1f,2c,4b': '2',
			'1f,2c,4c': '2',
			'1f,2c,4d': '3',
			'1f,2c,4e': '5',
			'1f,2d,4a': '2',
			'1f,2d,4b': '2',
			'1f,2d,4c': '2',
			'1f,2d,4d': '3',
			'1f,2d,4e': '3',
			'1f,2e,4a': '2',
			'1f,2e,4b': '2',
			'1f,2e,4c': '3',
			'1f,2e,4d': '3',
			'1f,2e,4e': '4',
			'1f,2f,4a': '2',
			'1f,2f,4b': '2',
			'1f,2f,4c': '3',
			'1f,2f,4d': '3',
			'1f,2f,4e': '4',
		};

		function matchResults() {
			var answerInputArray = userAnswers.split(',');
			var relevantAnswers = [];
			for (i = 0; i < answerInputArray.length; i++) {
				if (
					answerInputArray[i].charAt(0) == '1' ||
					answerInputArray[i].charAt(0) == '2' ||
					answerInputArray[i].charAt(0) == '4'
				) {
					relevantAnswers.push(answerInputArray[i]);
				}
			}
			relevantAnswers = relevantAnswers.toString();
			var matchedKey = possibleMatches[relevantAnswers];
			return matchedKey;
		}

		if ($('#quiz-results').length > 0) {
			if (userName == false) {
				if (window.Shopify.designMode == false) {
					window.location.href = '/pages/quiz';
				}
			} else {
				var answerKey = matchResults();
				console.log(answerKey);
				$('.resultOne__slider--' + answerKey).show();
				$('.resultTwo__slider--' + answerKey).show();

				if (answerKey == 1 || answerKey == 2) {
					$('.resultMain__title--one').show();
					$('.resultMain__text--one').show();
				}
				if (answerKey == 3 || answerKey == 4) {
					$('.resultMain__title--two').show();
					$('.resultMain__text--two').show();
				}
				if (answerKey == 5) {
					$('.resultMain__title--three').show();
					$('.resultMain__text--three').show();
				}

				function filterResultsByTag(tag) {
					var filterTagArray = tag.split(',');
					for (j = 0; j < filterTagArray.length; j++) {
						$('.resultOne__card').each(function () {
							var tagString = $(this).attr('dada-tags');
							var tagArray = tagString.split(',');
							for (i = 0; i < tagArray.length; i++) {
								if (tagArray[i] == filterTagArray[j]) {
									$(this).addClass('filterIn');
								}
							}
						});
						$('.resultTwo__card').each(function () {
							var tagString = $(this).attr('dada-tags');
							var tagArray = tagString.split(',');
							for (i = 0; i < tagArray.length; i++) {
								if (tagArray[i] == filterTagArray[j]) {
									$(this).addClass('filterIn');
								}
							}
						});
					}
					$('.resultOne__slider--1').slick(
						'slickFilter',
						'.filterIn'
					);
					$('.resultOne__slider--2').slick(
						'slickFilter',
						'.filterIn'
					);
					$('.resultOne__slider--3').slick(
						'slickFilter',
						'.filterIn'
					);
					$('.resultOne__slider--4').slick(
						'slickFilter',
						'.filterIn'
					);
					$('.resultOne__slider--5').slick(
						'slickFilter',
						'.filterIn'
					);

					$('.resultTwo__slider--1').slick(
						'slickFilter',
						'.filterIn'
					);
					$('.resultTwo__slider--2').slick(
						'slickFilter',
						'.filterIn'
					);
					$('.resultTwo__slider--3').slick(
						'slickFilter',
						'.filterIn'
					);
					$('.resultTwo__slider--4').slick(
						'slickFilter',
						'.filterIn'
					);
					$('.resultTwo__slider--5').slick(
						'slickFilter',
						'.filterIn'
					);
				}

				var answerInputArray = userAnswers.split(',');
				var filterArrayString = '';
				for (i = 0; i < answerInputArray.length; i++) {
					if (answerInputArray[i].charAt(0) == '6') {
						if (answerInputArray[i] == '6a') {
							console.log('wedding');
							filterArrayString += 'wedding,';
						}
						if (answerInputArray[i] == '6b') {
							filterArrayString += 'anniversary,';
						}
						if (answerInputArray[i] == '6c') {
							filterArrayString += 'new baby,';
						}
						if (answerInputArray[i] == '6d') {
							filterArrayString += 'religious event,';
						}
						if (answerInputArray[i] == '6e') {
							filterArrayString += 'holiday,';
						}
						if (answerInputArray[i] == '6f') {
							filterArrayString += 'memorial,';
						}
					}
				}
				if (filterArrayString != '') {
					filterArrayString = filterArrayString.slice(0, -1);
					filterResultsByTag(filterArrayString);
				}
			}
		}

		$('.resultsMain__name').text(userName);

		//cart-----------------------------------------------------------------------------------

		var upToDate = true;

		$('.cart__quantityMinus').on('click', function () {
			if (upToDate) {
				var currentQty =
					$(this).parent().find('.cart__quantity').text() * 1;
				var cartIndex = $(this)
					.parent()
					.parent()
					.parent()
					.attr('data-index');
				if (currentQty > 1) {
					CartJS.updateItem(cartIndex, currentQty - 1);
					$(this)
						.parent()
						.find('.cart__quantity')
						.text(currentQty - 1);
					upToDate = false;
				}
				listenForCartUpdate();
			}
		});

		$('.cart__quantityPlus').on('click', function () {
			if (upToDate) {
				var currentQty =
					$(this).parent().find('.cart__quantity').text() * 1;
				var cartIndex = $(this)
					.parent()
					.parent()
					.parent()
					.attr('data-index');

				CartJS.updateItem(cartIndex, currentQty + 1);
				$(this)
					.parent()
					.find('.cart__quantity')
					.text(currentQty + 1);
				upToDate = false;
				listenForCartUpdate();
			}
		});

		$('.cart__remove').on('click', function () {
			if (upToDate) {
				var cartIndex = $(this).parent().parent().attr('data-index');
				CartJS.removeItem(cartIndex);
				var cartIndex = $(this).parent().parent().slideUp();
				upToDate = false;
				listenForCartUpdate();
			}
		});

		function listenForCartUpdate() {
			var startPrice = CartJS.cart.total_price;
			var interval = setInterval(function () {
				if (CartJS.cart.total_price != startPrice) {
					clearInterval(interval);
					updateCart();
					upToDate = true;
				}
			}, 100);
		}

		function updateCart() {
			$('.cart__subTotal').text(
				'Subtotal $' + (CartJS.cart.total_price / 100).toFixed(2)
			);
			for (i = 0; i < CartJS.cart.items.length; i++) {
				$('[data-index="' + (i + 1) + '"]')
					.find('.cart__price')
					.text(
						'$' +
							(
								CartJS.cart.items[i].final_line_price / 100
							).toFixed(2)
					);
			}
		}

		//mobile account pages -----------------------------------------------------------------------

		$('.accountMob__button--home').on('click', function () {
			$('.accountMobNav').fadeOut();
		});

		$('.account__mobileArrowLink--home').on('click', function () {
			$('.accountMobNav').fadeIn();
		});

		//wishlist app fix attempts ------------------------------------------------------------------

		/*
    $('a').each(function(){
      var href = $(this).attr('href');
      var addedHref = href+'?swaction=clearcache';
      $(this).attr('href', addedHref);
    });
    */

		// login managed nav --------------------------------------------------------------------------
		if ($('.customer-logged-in').length) {
			$('.nav__rightInner--loggedOut').hide();
			$('.nav__rightInner--loggedIn').show();
			$('.nav__rightInner--loggedIn').attr('style', 'display:flex;');
		}
		if ($('.box-purchased').length) {
			$('.nav__rightInner--loggedOut').hide();
			$('.nav__rightInner--loggedIn').hide();
			$('.nav__rightInner--returning').show();
			$('.nav__rightInner--returning').attr('style', 'display:flex;');
		}

		// extra --------------------------------------------------------------------------------------

		$('.leftover__button, .savePricing__button').mouseenter(function () {
			$('.bsub-widget__plan-label').last().click();
		});

		$('[dress-box-buy]').on('click', function () {
			$('.boxForm').submit();
		});
	}
	pageLoadFunctions();

	/*
  barba.use(barbaCss);
  barba.init({
    cacheIgnore: true
  });
  
  barba.hooks.beforeEnter(() => {
	pageLoadFunctions();
  	window.scrollTo(0, 0);
  });
  */
});
